import {
    ADSENSE
} from "../../constants/ActionTypes";

const INIT_STATE = {
    adsenseData: {}
};

export default (state = INIT_STATE, action) => {
    
    switch (action.type) {
        case ADSENSE: {
            return {
                ...state,
                adsenseData: action.payload,
            }
        }

        default:
            return state;
    }
}